import React from 'react';
import { LANG_KEY, TOKEN_KEY, USER_KEY } from '../../constants/constants';
import { saveState } from '../../utils';
const withAuthData = (Component) => ({ ...props }) => {
    const queryParams = new URLSearchParams(window.location.search);
    const data = { token: null, userId: null, lang: null };
    if (queryParams.has(TOKEN_KEY)) {
        data.token = queryParams.get(TOKEN_KEY);
        saveState(TOKEN_KEY, queryParams.get(TOKEN_KEY));
        queryParams.delete(TOKEN_KEY);
    }
    if (queryParams.has(USER_KEY)) {
        data.userId = queryParams.get(USER_KEY);
        queryParams.delete(USER_KEY);
    }
    if (queryParams.has(LANG_KEY)) {
        data.lang = queryParams.get(LANG_KEY);
        saveState(LANG_KEY, data.lang);
        queryParams.delete(LANG_KEY);
    }
    if (data.token || data.userId || data.lang)
        window.history.replaceState({}, '', queryParams.toString() !== ''
            ? `${window.location.pathname}?${queryParams}`
            : window.location.pathname);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return React.createElement(Component, { ...props, ...data });
};
export default withAuthData;
//# sourceMappingURL=withAuthData.js.map